
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.Dm_capScalarFieldEnum = {
  cap_id: 'cap_id',
  tencap: 'tencap',
  stt: 'stt',
  trangthai_id: 'trangthai_id',
  icon: 'icon',
  iconColor: 'iconColor'
};

exports.Prisma.Dm_huyenScalarFieldEnum = {
  huyen_id: 'huyen_id',
  ten_huyen: 'ten_huyen',
  stt: 'stt',
  style: 'style',
  toado_center: 'toado_center',
  geojson: 'geojson'
};

exports.Prisma.Dm_loaihinhScalarFieldEnum = {
  loaihinh_id: 'loaihinh_id',
  loaihinh: 'loaihinh',
  stt: 'stt',
  trangthai_id: 'trangthai_id',
  icon: 'icon',
  iconColor: 'iconColor'
};

exports.Prisma.Dm_trangthai_chungScalarFieldEnum = {
  trangthai_id: 'trangthai_id',
  ten_trangthai: 'ten_trangthai',
  stt: 'stt',
  canh_bao: 'canh_bao'
};

exports.Prisma.Phong_giaoducScalarFieldEnum = {
  phong_id: 'phong_id',
  tenphong: 'tenphong',
  stt: 'stt',
  huyen_id: 'huyen_id',
  toado: 'toado',
  chitiet: 'chitiet',
  diachi: 'diachi',
  dienthoai: 'dienthoai',
  email: 'email',
  website: 'website',
  so_id: 'so_id',
  tomtat: 'tomtat',
  hinh_daidien: 'hinh_daidien',
  ngay_cn: 'ngay_cn',
  nguoi_cap_nhat_id: 'nguoi_cap_nhat_id'
};

exports.Prisma.So_giaoducScalarFieldEnum = {
  so_id: 'so_id',
  tenso: 'tenso',
  stt: 'stt',
  toado: 'toado',
  diachi: 'diachi',
  dienthoai: 'dienthoai',
  email: 'email',
  website: 'website',
  tomtat: 'tomtat',
  chitiet: 'chitiet',
  hinh_daidien: 'hinh_daidien',
  ngay_cn: 'ngay_cn',
  nguoi_cap_nhat_id: 'nguoi_cap_nhat_id'
};

exports.Prisma.Refresh_tokenScalarFieldEnum = {
  id: 'id',
  token: 'token',
  user_id: 'user_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  logout_time: 'logout_time',
  device: 'device',
  ip_address: 'ip_address',
  is_active: 'is_active'
};

exports.Prisma.Truong_hocScalarFieldEnum = {
  truong_id: 'truong_id',
  ma_truong: 'ma_truong',
  ma_moet: 'ma_moet',
  ten_truong: 'ten_truong',
  loaihinh_id: 'loaihinh_id',
  diachi: 'diachi',
  dienthoai: 'dienthoai',
  email: 'email',
  toado: 'toado',
  tomtat: 'tomtat',
  chitiet: 'chitiet',
  website: 'website',
  hinh_daidien: 'hinh_daidien',
  phong_id: 'phong_id',
  ngay_tao: 'ngay_tao',
  nguoi_tao_id: 'nguoi_tao_id',
  ngay_update: 'ngay_update',
  nguoi_update_id: 'nguoi_update_id',
  trangthai_id: 'trangthai_id'
};

exports.Prisma.Truonghoc_caphocScalarFieldEnum = {
  truong_id: 'truong_id',
  cap_id: 'cap_id'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  password: 'password',
  created_at: 'created_at',
  updated_at: 'updated_at',
  is_active: 'is_active',
  username: 'username',
  fullname: 'fullname',
  giaovien_id: 'giaovien_id',
  avatar: 'avatar',
  nguoi_tao_id: 'nguoi_tao_id',
  nguoi_cap_nhat_id: 'nguoi_cap_nhat_id'
};

exports.Prisma.Dm_chucvuScalarFieldEnum = {
  chucvu_id: 'chucvu_id',
  ten_chucvu: 'ten_chucvu',
  trangthai_id: 'trangthai_id',
  ngay_tao: 'ngay_tao',
  ngay_cap_nhat: 'ngay_cap_nhat',
  nguoi_tao_id: 'nguoi_tao_id',
  nguoi_cap_nhat_id: 'nguoi_cap_nhat_id'
};

exports.Prisma.Dm_to_bomonScalarFieldEnum = {
  tobm_id: 'tobm_id',
  ten_to_bomon: 'ten_to_bomon',
  trangthai_id: 'trangthai_id',
  ngay_tao: 'ngay_tao',
  ngay_cap_nhat: 'ngay_cap_nhat',
  nguoi_tao_id: 'nguoi_tao_id',
  nguoi_cap_nhat_id: 'nguoi_cap_nhat_id'
};

exports.Prisma.Giao_vienScalarFieldEnum = {
  giaovien_id: 'giaovien_id',
  ho_ten: 'ho_ten',
  ma_giaovien: 'ma_giaovien',
  chucvu_id: 'chucvu_id',
  dien_thoai: 'dien_thoai',
  email: 'email',
  so_cmnd: 'so_cmnd',
  tobm_id: 'tobm_id',
  ngay_sn: 'ngay_sn',
  ho_khau: 'ho_khau',
  ngay_tao: 'ngay_tao',
  ngay_cap_nhat: 'ngay_cap_nhat',
  nguoi_tao_id: 'nguoi_tao_id',
  nguoi_cap_nhat_id: 'nguoi_cap_nhat_id',
  truong_id: 'truong_id',
  gioi_tinh: 'gioi_tinh',
  trangthai_id: 'trangthai_id'
};

exports.Prisma.Dm_dantocScalarFieldEnum = {
  dantoc_id: 'dantoc_id',
  ma_dantoc: 'ma_dantoc',
  dan_toc: 'dan_toc'
};

exports.Prisma.Dm_khoiScalarFieldEnum = {
  khoi_id: 'khoi_id',
  ten_khoi: 'ten_khoi',
  stt: 'stt',
  cap_id: 'cap_id'
};

exports.Prisma.Lop_hocScalarFieldEnum = {
  lophoc_id: 'lophoc_id',
  ten_lophoc: 'ten_lophoc',
  ma_lophoc: 'ma_lophoc',
  khoi_id: 'khoi_id',
  so_hocsinh: 'so_hocsinh',
  so_nam: 'so_nam',
  so_nu: 'so_nu',
  so_dienchinhsach: 'so_dienchinhsach',
  so_canngheo: 'so_canngheo',
  namhoc_id: 'namhoc_id',
  truong_id: 'truong_id',
  trangthai_id: 'trangthai_id',
  ngay_tao: 'ngay_tao',
  ngay_cap_nhat: 'ngay_cap_nhat',
  nguoi_tao_id: 'nguoi_tao_id',
  nguoi_cap_nhat_id: 'nguoi_cap_nhat_id',
  chunhiem_id: 'chunhiem_id'
};

exports.Prisma.Lophoc_dantocScalarFieldEnum = {
  lophoc_id: 'lophoc_id',
  dantoc_id: 'dantoc_id',
  so_luong: 'so_luong'
};

exports.Prisma.Dm_namhocScalarFieldEnum = {
  namhoc_id: 'namhoc_id',
  nam_hoc: 'nam_hoc',
  stt: 'stt',
  is_active: 'is_active'
};

exports.Prisma.MenuScalarFieldEnum = {
  menu_id: 'menu_id',
  ma_menu: 'ma_menu',
  ten_menu: 'ten_menu',
  stt: 'stt',
  path: 'path',
  menu_cha_id: 'menu_cha_id',
  icon: 'icon',
  ngay_tao: 'ngay_tao',
  ngay_cap_nhat: 'ngay_cap_nhat',
  nguoi_tao_id: 'nguoi_tao_id',
  nguoi_cap_nhat_id: 'nguoi_cap_nhat_id',
  ghi_chu: 'ghi_chu',
  trangthai_id: 'trangthai_id',
  is_hidden: 'is_hidden'
};

exports.Prisma.Nhom_quyenScalarFieldEnum = {
  nhomquyen_id: 'nhomquyen_id',
  ma_nhomquyen: 'ma_nhomquyen',
  ten_nhomquyen: 'ten_nhomquyen',
  mo_ta: 'mo_ta',
  ngay_tao: 'ngay_tao',
  ngay_cap_nhat: 'ngay_cap_nhat',
  nguoi_tao_id: 'nguoi_tao_id',
  nguoi_cap_nhat_id: 'nguoi_cap_nhat_id',
  is_macdinh: 'is_macdinh',
  trangthai_id: 'trangthai_id'
};

exports.Prisma.User_nhomquyenScalarFieldEnum = {
  user_nhomquyen_id: 'user_nhomquyen_id',
  user_id: 'user_id',
  nhomquyen_id: 'nhomquyen_id',
  ngay_tao: 'ngay_tao',
  ngay_cap_nhat: 'ngay_cap_nhat',
  nguoi_tao_id: 'nguoi_tao_id',
  nguoi_cap_nhat_id: 'nguoi_cap_nhat_id'
};

exports.Prisma.Nhomquyen_menuScalarFieldEnum = {
  nhomquyen_menu_id: 'nhomquyen_menu_id',
  nhomquyen_id: 'nhomquyen_id',
  menu_id: 'menu_id',
  ngay_tao: 'ngay_tao',
  nguoi_tao_id: 'nguoi_tao_id',
  quyen_id: 'quyen_id'
};

exports.Prisma.QuyenScalarFieldEnum = {
  quyen_id: 'quyen_id',
  ma_quyen: 'ma_quyen',
  ten_quyen: 'ten_quyen'
};

exports.Prisma.User_quyen_dulieuScalarFieldEnum = {
  user_quyen_dulieu_id: 'user_quyen_dulieu_id',
  user_id: 'user_id',
  cap_donvi: 'cap_donvi',
  so_id: 'so_id',
  phong_id: 'phong_id',
  truong_id: 'truong_id',
  ngay_tao: 'ngay_tao',
  nguoi_tao_id: 'nguoi_tao_id'
};

exports.Prisma.PublicTokenScalarFieldEnum = {
  id: 'id',
  token: 'token',
  description: 'description',
  created_at: 'created_at',
  expires_at: 'expires_at',
  is_active: 'is_active'
};

exports.Prisma.LogScalarFieldEnum = {
  log_id: 'log_id',
  user_id: 'user_id',
  api_endpoint: 'api_endpoint',
  method: 'method',
  status_code: 'status_code',
  response_time: 'response_time',
  ip_address: 'ip_address',
  user_agent: 'user_agent',
  body: 'body',
  query: 'query',
  params: 'params',
  message: 'message',
  api_type: 'api_type',
  action_type: 'action_type',
  created_at: 'created_at'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.CapDonVi = exports.$Enums.CapDonVi = {
  so: 'so',
  phong: 'phong',
  truong: 'truong'
};

exports.ApiType = exports.$Enums.ApiType = {
  PUBLIC: 'PUBLIC',
  AUTHENTICATED: 'AUTHENTICATED'
};

exports.ActionType = exports.$Enums.ActionType = {
  VIEW: 'VIEW',
  MANIPULATE: 'MANIPULATE'
};

exports.Prisma.ModelName = {
  dm_cap: 'dm_cap',
  dm_huyen: 'dm_huyen',
  dm_loaihinh: 'dm_loaihinh',
  dm_trangthai_chung: 'dm_trangthai_chung',
  phong_giaoduc: 'phong_giaoduc',
  so_giaoduc: 'so_giaoduc',
  refresh_token: 'refresh_token',
  truong_hoc: 'truong_hoc',
  truonghoc_caphoc: 'truonghoc_caphoc',
  user: 'user',
  dm_chucvu: 'dm_chucvu',
  dm_to_bomon: 'dm_to_bomon',
  giao_vien: 'giao_vien',
  dm_dantoc: 'dm_dantoc',
  dm_khoi: 'dm_khoi',
  lop_hoc: 'lop_hoc',
  lophoc_dantoc: 'lophoc_dantoc',
  dm_namhoc: 'dm_namhoc',
  menu: 'menu',
  nhom_quyen: 'nhom_quyen',
  user_nhomquyen: 'user_nhomquyen',
  nhomquyen_menu: 'nhomquyen_menu',
  quyen: 'quyen',
  user_quyen_dulieu: 'user_quyen_dulieu',
  PublicToken: 'PublicToken',
  log: 'log'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
